export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9847.66225ec7.jpg";